import { render, staticRenderFns } from "./NormTitle.vue?vue&type=template&id=07c53d1a&scoped=true&"
import script from "./NormTitle.vue?vue&type=script&lang=js&"
export * from "./NormTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c53d1a",
  null
  
)

export default component.exports